import React, { FC } from "react"
import { Select } from "antd"
import { getGameOptionsWithNumberValues } from "./gameOptions"

const gameOptions = getGameOptionsWithNumberValues()

interface GameSelectProps {
  value?: number
  onChange?: (value: number) => void
  placeholder?: string
  style?: React.CSSProperties
}

export const GameSelect: FC<GameSelectProps> = ({
  value,
  onChange,
  placeholder = "Select a game",
  style,
}) => {

  return (
    <Select
      placeholder={placeholder}
      showSearch
      optionFilterProp="label"
      options={gameOptions}
      value={value}
      onChange={onChange}
      style={style}
      filterOption={(input, option) => {
        const searchValue = input.toLowerCase()
        const label = String(option?.label ?? "").toLowerCase()
        const optValue = String(option?.value ?? "").toLowerCase()

        return label.includes(searchValue) || optValue.includes(searchValue)
      }}
    />
  )
}
